<template>
  <div class="list-page">
      <transition name="fade" mode="out-in">
          <div key="list" class="bg-wrap-color">
              <el-form
                  :inline="true"
                  :model="formData"
                  ref="formData"
                  class="demo-form-inline bg-color"
                  size="mini"
                  @submit.native.prevent="onSubmit"
              >
                  <el-form-item  prop="task_id">
                    <custom-input label="任务ID">
                         <el-input
                            v-model="formData.task_id"
                            placeholder="任务ID"
                            style="width: 100px"
                            clearable
                            @keyup.enter.native="onSubmit"
                        ></el-input>
                    </custom-input>
                     
                  </el-form-item>
                  <el-form-item  prop="account_id">
                    <custom-input label="目标账户">
                        <ESelect
                            v-model="formData.account_id"
                            placeholder="账户名称关键字或账户ID搜索"
                            style="width: 260px"
                            class="tagswidth select-option-long-text-wrap remote-select-tags-width"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            reserve-keyword
                            remote
                            :loading="accountOptionsLoading"
                            :remote-method="remoteAccountSearchList"
                        >
                            <el-option
                                v-for="item in account"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </ESelect>
                       </custom-input>
                  </el-form-item>
                  <el-form-item  prop="app_id">
                    <custom-input label="投放产品">
                        <ESelect
                            v-model="formData.app_id"
                            placeholder="产品名称关键字或产品ID搜索"
                            style="width: 260px"
                            class="tagswidth select-option-long-text-wrap remote-select-tags-width"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            reserve-keyword
                            remote
                            :loading="appOptionsLoading"
                            :remote-method="remoteAppSearchList"
                        >
                            <el-option
                                v-for="item in app"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </ESelect>
                      </custom-input>
                  </el-form-item>
                  <el-form-item  prop="creator">
                        <custom-input label="创建人">
                            <ESelect
                                v-model="formData.creator"
                                placeholder="支持名称关键字搜索"
                                style="width: 160px"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                            >
                                <el-option
                                    v-for="item in creator"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </ESelect>
                       </custom-input>
                  </el-form-item>
                  <el-form-item  prop="department" >
                     <custom-input label="创建部门">
                      <ESelect
                          v-model="formData.department"
                          placeholder="支持名称关键字搜索"
                          style="width: 180px"
                          clearable
                          filterable
                          multiple
                          collapse-tags
                      >
                          <el-option
                              v-for="item in department"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                      </ESelect>
                     </custom-input>
                  </el-form-item>
                  <el-form-item  prop="range_time">
                    <custom-input label="创建时间">
                      <el-date-picker
                          v-model="range_time"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="basePickerOptions"
                          value-format="yyyy-MM-dd"
                          :clearable="false"
                          style="width: 240px"
                      >
                      </el-date-picker>
                    </custom-input>
                  </el-form-item>
                  <el-form-item  prop="status">
                    <custom-input label="任务状态">
                      <el-select
                          v-model="formData.status"
                          placeholder="任务状态"
                          style="width: 180px"
                          multiple
                          collapse-tags
                          clearable
                      >
                          <el-option
                              label="创建中"
                              value="1"
                          ></el-option>
                          <el-option
                              label="创建成功"
                              value="2"
                          ></el-option>
                          <el-option
                              label="创建失败"
                              value="3"
                          ></el-option>
                          <el-option
                              label="部分创建失败"
                              value="4"
                          ></el-option>
                      </el-select>
                    </custom-input>
                  </el-form-item>

                  <el-divider class="mt0 mb10" />
                  <el-form-item class="">
                      <el-button type="primary" @click="onSubmit" :loading="loading" v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '筛选(查询)' }">查询</el-button>
                      <el-button @click="resetForm('formData',true)" v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '筛选(清空筛选)' }">清空筛选</el-button>
                  </el-form-item>
              </el-form>
              <div class="bg-color">
                  <div class="pt10 pl20 pr10 pb10">
                      <el-button
                          v-if="isHasBatchCreate"
                          type="primary"
                          @click="toConfigPage"
                          size="mini"
                          v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '批量创建' }"
                      >批量创建</el-button>
                  </div>
                  <jt-table
                      :data=" [ totalData , ...tableData] "
                      style="width: 100%"
                      stripe
                      :header-cell-style="{background:'#e8eaec',color:'#333'}"
                      size="mini"
                      class="create_list"
                      :row-class-name="tableRowClassName"
                      v-loading="loading"
                      tooltip-effect="dark"
                  >
                      <el-table-column label="任务ID" width="80" prop="id">
                          <template slot-scope="scope">
                              <span v-if="scope.$index != 0">{{ scope.row.id }}</span>
                              <span v-else class="text-bold">汇总</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="目标账户" min-width="240" show-overflow-tooltip>
                          <template slot-scope="scope">
                              <div v-if="scope.$index != 0">
                                  <p class="ellipsis">{{scope.row.account_name}}</p>
                              </div>
                              <span v-else>{{scope.row.account_num_distinct}} / {{scope.row.account_num}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="投放产品" min-width="200">
                          <template slot-scope="scope">
                              <div v-if="scope.$index != 0">
                                  <div v-for="(item, index) in scope.row.app||[]" :key="index">
                                      <p>{{item.app_name||'--'}}</p>
                                      <p>{{item.package_name}}</p>
                                  </div>
                              </div>
                              <span v-else>{{scope.row.app_num_distinct}} / {{scope.row.app_num}}</span>
                          </template>
                      </el-table-column>
                     
                      
                      <el-table-column
                          label="创建计划规格(成功数量/总量)"
                          min-width="260"
                          show-overflow-tooltip
                      >
                          <template slot-scope="scope">
                              <div>
                                  <p class="ellipsis">
                                      计划(<span class="text-color-success">{{ scope.row.plan_num }}</span>/<span>{{ scope.row.plan_total }}</span>)；
                                      广告组(<span class="text-color-success">{{ scope.row.adgroup_num }}</span>/<span>{{ scope.row.adgroup_total }}</span>)；
                                      广告创意(<span class="text-color-success">{{ scope.row.ad_num }}</span>/<span>{{ scope.row.ad_total }}</span>)；</p>
                              </div>
                          </template>
                      </el-table-column>
                      <el-table-column label="任务状态" min-width="100">
                          <template slot-scope="scope">
                              <div v-if="scope.$index != 0">
                                  <!-- 1-创建中，2-成功，3-失败，4-部分失败  -->
                                  <p v-if="scope.row.status == 1" style="color: #409eff;">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                                  <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                                  <div v-else class="text-color-error text-nowrap">
                                      <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                        <div slot="content">
                                            <p class="mb6">您可点击任务详情查看具体失败计划，失败原因如下：</p>
                                            <div v-html="scope.row.err_msg.replace(/\\n/g, '<br/>')"></div>
                                        </div>
                                        <span class="pointer">{{ scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                                    </el-tooltip>
                                      <span v-else>{{ scope.row.status_text}}</span>
                                  </div>
                                  <!--<p v-else-if="scope.row.status == 3" class="text-color-error">{{ scope.row.status_text}}</p>-->
                                  <!--<p v-else-if="scope.row.status == 4" class="text-color-error">{{ scope.row.status_text}}</p>-->
                                  <!--<span v-else>-</span>-->
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="创建人" width="90" prop="name">
                          <template slot-scope="scope">
                              <span v-if="scope.$index != 0">{{ scope.row.name }}</span>
                              <span v-else>{{scope.row.creator_num_distinct}} / {{scope.row.creator_num}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="投放版位大类" min-width="200">
                          <template slot-scope="{ row, $index }">
                              <div v-if="$index != 0">
                                  {{ row.creative_size_name }}
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="投放版位" min-width="200">
                          <template slot-scope="{ row, $index }">
                              <div v-if="$index != 0">
                                  {{ row.display_type_text }}
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="计划分配规则" min-width="200">
                          <template slot-scope="{ row , $index}">
                              <div v-if="$index != 0">
                                  {{ row.plan_allocation_rules.toString() }}
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="广告组分配规则" min-width="200">
                          <template slot-scope="{ row, $index }">
                              <div v-if="$index != 0">
                                  {{ row.adgroup_allocation_rules.toString() }}
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="广告分配规则" min-width="200">
                          <template slot-scope="{ row, $index }">
                              <div v-if="$index != 0">
                                  {{ row.element_group_allocation_rules }}
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="创建时间" width="90">
                          <template slot-scope="scope">
                              <span v-if="scope.$index != 0">{{ scope.row.ctime||'-' }}</span>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="操作" align="center" width="180" fixed="right">
                          <template slot-scope="scope">
                              <template v-if="scope.$index != 0">
                                  <el-button  size="mini" type="text" @click="handleClick( scope.row)" v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '列表(任务详情)' }">任务详情</el-button>
                                  <el-button  size="mini" type="text" @click="toCopyConfigPage(scope.row)" v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '列表(复制)' }">复制</el-button>
                                  <el-button v-if="isHasRetryAuth" :disabled="!scope.row.status||scope.row.status=='1'||scope.row.status=='2'" :loading="scope.row.retryLoading" size="mini" type="text" @click="retryTask(scope.row)" v-matomo="{behaviorCategory: '华为Ads(批量搭建)',  name: '列表(重试)' }">重试</el-button>
                              </template>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                  </jt-table>
                  <div class="tar pt20 pr20">
                      <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="pageNum"
                          :page-sizes="[ 30, 50, 100]"
                          :page-size="pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                      >
                      </el-pagination>
                  </div>
              </div>

          </div>

      </transition>


  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import dayjs from "dayjs";
    import {
        getBatchQueryAccountListApi,
        getBatchQueryAppListApi,
        getBatchQueryUserListApi,
        getBatchQueryDepartmentListApi,
        getBatchTotalDataApi,
        getBatchListApi,
        retryBatchTaskApi
     } from '@/api'
    const getDefaultFormData = () => {
        return {
            task_id: "",        //任务ID
            account_id: "",     //账户ID
            app_id:"",  //产品
            creator: "",        //创始人
            department: "",     //创始部门
            status:""           //任务状态
        }
    }
    export default {
        props:{
            pageFuncNames:Array,
            pageDimensionNames:Array,
            pageName: String,
            platId: {
                type: Number,
                default: 10
            }
        },
        components: {
        },
        data() {
            return {
                loading: false,
                pageNum: 1,
                pageSize: 30,
                total: 10,
                tableData:[],
                totalData:{},//汇总数据
                range_time:[dayjs().subtract(6,'day').format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],      //创建时间
                account: [],            //select搜索
                app:[],            //select搜索
                creator: [],            //select搜索
                department: [],            //select搜索
                formData: getDefaultFormData(),
                basePickerOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [
                        {
                            text: '最近7天',
                            onClick(picker) {
                                const date = new Date();
                                let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                                let endDate = new Date(date.getTime());
                                picker.$emit('pick', [startDate,endDate]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                // 上周：自然周，周一到周日
                                let date = new Date(new Date().getTime()-1000*60*60*24*7);
                                let weekDay = date.getDay();
                                let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth();
                                let startDate = new Date(year+'-'+month+'-01');
                                let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;

                                let startDate='';
                                let endDate = '';
                                if([1,2,3].includes(month)){
                                    startDate = (year-1)+'-10-01';
                                    endDate = (year-1)+'-12-31';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-01-01';
                                    endDate = year+'-03-31';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-04-01';
                                    endDate = year+'-06-30';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-07-01';
                                    endDate = year+'-09-30';
                                }
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '今年',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let startDate= year+'-01-01';
                                let endDate = year+'-12-31';
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '去年',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear()-1;
                                let startDate= year+'-01-01';
                                let endDate = year+'-12-31';
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                },
                accountOptionsLoading:false,
                appOptionsLoading:false,
                stateList: [],//任务状态
                refreshLoading:false, //刷新loading
                refreshTime: null, //刷新时间
            }
        },
        computed:{
            isHasBatchCreate(){
                return this.pageFuncNames.includes('huawei_ads_batch_create');
            },
            isHasRetryAuth(){
                return this.pageFuncNames.includes('huawei_ads_retry_task');
            },
        },
        mounted() {
          window.localStorage.removeItem('huawei_ads_batch')
          this.formData.task_id = this.$route.query.id || '';
          this.getPageAllData()
        },
        methods: {
            handleClick(row) {
                this.$emit('to-page', 'InfoPage', row)
            },
            toCopyConfigPage(row) {
                this.$emit('to-page', 'ConfigPage', row)
            },
            toConfigPage() {
                this.$emit('to-page', 'ConfigPage')
            },
            async retryTask(row) {
                const params = {
                    task_id: row.id,
                    plat_id: 10,
                }
                try {
                    this.loading= true;
                    await retryBatchTaskApi(params);
                } catch (error) {
                    this.$message.error(error.info)
                    this.loading= false;
                    return;
                }
                this.pageNum = 1;
                this.getPageAllData()
            },
            onSubmit() {
                this.pageNum = 1;
                this.getPageAllData()
            },
            resetForm() {
                this.formData = getDefaultFormData()
                this.pageNum = 1;
                this.getPageAllData()
            },
            handleSizeChange(val) {
                this.pageNum = 1;
                this.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getList();
            },
            // 获取全部数据
            async getPageAllData() {
                this.getTotalData();
                this.getList();
            },
            async getTotalData() {
                const { data } = await getBatchTotalDataApi(this.getParamsData());
                this.totalData = data;
                const params = { plat_id: this.platId};
                if (!(this.creator.length && this.department.length)) {
                    Promise.all([
                        getBatchQueryUserListApi(params),
                        getBatchQueryDepartmentListApi(params)
                    ])
                    .then(([ userData, depData ])=>{
                        // creator: [],            //select搜索
                        // department: [],  
                        this.creator = userData.data.list
                        this.department = depData.data.list
                    })
                }
            },
            // 获取列表数据
            async getList() {
                try {
                    this.loading = true;
                   
                    const params = {
                        ...this.getParamsData(),
                        pn: this.pageNum,
                        rn: this.pageSize,
                    };
                    const { data } = await getBatchListApi(params);
                    // item.status
                    const stateList = data.list.filter(v=>{
                        return [ 1, 6 ].includes(v.status)
                    }).map(v=>v.id);
                    this.stateList = stateList;
                    this.tableData = data.list;
                    this.total = data.totalCnt;
                    this.refreshTime&&clearTimeout(this.refreshTime);
                    // this.refreshList(params)
                } catch (error) {
                    console.log(error, '获取列表失败');
                }finally{
                    this.loading = false;
                }
            },
            async refreshList(params) {
                if(!this.stateList.length || this.refreshLoading) {
                    return
                };
                this.refreshLoading = true;
                const { data } = await getBatchListApi(params);
                const stateList = data.list.filter(v=>{
                    return ![ 1, 6 ].includes(v.status)
                }).map(v=>v.id);
                if (this.stateList.some(v=>stateList.includes(v))) {
                    this.tableData = data.list;
                }
                this.refreshLoading = false;
                this.refreshTime = setTimeout(()=>{
                    this.refreshList(params)
                }, 5 * 1000)
            },
            getParamsData() {
                const { task_id, account_id, app_id, creator, department, status } = this.formData;
                const range_time = this.range_time.map(item=>dayjs(item).format('YYYY-MM-DD')).join('/');
                return {
                    plat_id: this.platId,
                    task_id,
                    account_id: account_id.toString(),
                    app_id: app_id.toString(),
                    creator: creator.toString(),
                    department: department.toString(),
                    status: status.toString(),
                    range_time,
                }
            },
            async remoteAccountSearchList(query) {
                this.accountOptionsLoading = true;
                const params = {
                    query,
                    plat_id: this.platId,
                }
                const { data } = await getBatchQueryAccountListApi(params);
                this.account = data.list;
                if(this.account.length >200) {
                    this.account = this.account.slice(0,200);
                }
                this.accountOptionsLoading = false;
            },
            async remoteAppSearchList(query) {
                this.appOptionsLoading = true;
                const params = {
                    query,
                    plat_id: this.platId,
                }
                const { data } = await getBatchQueryAppListApi(params);
                this.app = data.list;
                if(this.app.length >200) {
                    this.app = this.account.slice(0,200);
                }
                this.appOptionsLoading = false;
            },
            tableRowClassName({ row, rowIndex }) {
                if (rowIndex === 0) {
                    return 'gray-row';
                }
                return '';
            }
        },
        activated() {
            this.getList()
        },
        deactivated() {
            this.stateList= []
        },
        beforeDestroy() {
            this.stateList= []
        },
    }
</script>

<style lang="scss" scoped>
.list-page ::v-deep.el-table .gray-row{
    background-color: #f4f4f4;
}
.demo-form-inline{
    padding: 10px 20px 0;
    margin-bottom: 10px;
}
    .mt0{
        margin-top: 0;
    }
    .bg-wrap-color{
        background-color:#F1F4F9;
    }
    .bg-color{
        background-color:#FFF;
    }

</style>
